<template>
  <div
    :class="{ question: true, 'question--association': type === 'association' }"
  >
    <!-- <div class="multiplechoice" v-if="type === 'multiple choice'">
      need to build dropdown component: {{ options }}
    </div> -->

    <!-- <div class="yesno" v-if="type === 'yesno'">
      <div
        class="answer"
        v-bind:class="{ active: answer.input === 'Yes' }"
        @click="answer.input = 'Yes'"
      >
        <p>Yes</p>
      </div>
      <div
        class="answer"
        @click="answer.input = 'No'"
        v-bind:class="{ active: answer.input === 'No' }"
      >
        <p>No</p>
      </div>
    </div> -->
    <div v-if="type === 'association'">
      <bg-loader
        :dark="true"
        style="position: relative; float: right; top: 0px; left: 0px"
        v-if="savingInProgress"
      ></bg-loader>
      <transition name="fade">
        <div class="checkmark-association" v-if="savingSuccessfull"></div>
      </transition>
      <bg-checkbox
        :value="answer.input"
        :label="title"
        @change="handleAssociationUpdate"
        class="checkbox"
        :outline="true"
      />
    </div>
    <div v-else>
      <div class="title">
        <h3 style="margin-bottom: 0px; margin-top: 0px; font-size: 14pt">
          {{ index + 1 }}. {{ title }}
        </h3>
      </div>
      <bg-loader
        :dark="true"
        style="position: relative; float: right; top: -35px; left: 39px"
        v-if="savingInProgress"
      ></bg-loader>
      <transition name="fade">
        <div class="checkmark" v-if="savingSuccessfull"></div>
      </transition>
      <p style="margin-top: 0px; margin-bottom: 10px; font-size: 12pt">
        {{ subtitle }}
      </p>
      <div class="scale" v-if="type === 'scale'">
        <div
          class="unit"
          :class="{ active: score === answer.input }"
          v-for="(score, index) in scaleItems"
          :key="index"
          @click="handleScaleAnswer(score)"
        >
          <span>{{ score }}</span>
        </div>
      </div>
      <div class="open" v-if="type === 'open'">
        <textarea v-model="answer.input" @blur="handleLoseFocus"> </textarea>
      </div>

      <div class="comment" v-if="answer.input && type != 'open'">
        <p style="margin-bottom: 5px; font-size: 12pt">
          <i>Please elaborate:</i>
        </p>
        <input
          type="text"
          v-model="answer.elaboration"
          @blur="handleLoseFocus"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
import API from "@/api";
import BgLoader from "@/components/bg-loader";
import BgCheckbox from "@/components/bg-checkbox";

export default {
  components: {
    BgLoader,
    BgCheckbox,
  },
  props: {
    title: String,
    subtitle: String,
    type: String,
    options: Array,
    index: Number,
    questionId: Number,
    existingAnswer: Object,
    participantId: Number,
  },
  data() {
    return {
      scaleItems: [1, 2, 3, 4, 5],
      score: null,
      answer: {
        type: this.type,
        input: null,
        elaboration: "",
        index: this.index,
        questionId: this.questionId,
        answerId: null,
      },
      savingInProgress: false,
      savingSuccessfull: false,
    };
  },
  methods: {
    select(score) {
      this.answer.input = score;
    },
    handleScaleAnswer(score) {
      this.select(score);
      this.$emit("answered", this.answer);
      this.saveAnswer(this.answer);
    },
    handleLoseFocus() {
      this.$emit("answered", this.answer);
      this.saveAnswer(this.answer);
    },
    handleAssociationUpdate(input) {
      this.answer.input = input;
      this.saveAnswer(this.answer);
    },
    async saveAnswer(answer) {
      const payload = {
        text: answer.type === "open" ? answer.input : answer.elaboration,
        score: answer.type === "scale" ? answer.input : null,
        question_id: answer.questionId,
        participant_id: this.participantId,
        checked: answer.type === "association" ? answer.input : null,
      };
      if (answer.answerId) {
        this.savingInProgress = true;
        if (answer.type === "association") {
          await API.answer.deleteAnswer(answer.answerId);
          answer.answerId = null;
        } else {
          await API.answer.updateAnswer(answer.answerId, payload);
        }
        this.savingInProgress = false;
        this.savingSuccessfull = true;
        setTimeout(() => {
          this.savingSuccessfull = false;
        }, 500);
      } else {
        this.savingInProgress = true;
        const data = await API.answer.createAnswer(payload);
        answer.answerId = data.id;
        this.savingInProgress = false;
        this.savingSuccessfull = true;
        setTimeout(() => {
          this.savingSuccessfull = false;
        }, 500);
      }
    },
  },
  mounted() {
    if (this.existingAnswer) {
      this.answer.answerId = this.existingAnswer.id;
      if (this.answer.type === "scale") {
        this.answer.input = parseInt(this.existingAnswer.score);
        this.answer.elaboration = this.existingAnswer.text;
      } else if (this.answer.type === "association") {
        this.answer.input = true;
      } else {
        this.answer.input = this.existingAnswer.text;
      }
    }
  },
};
</script>
